import styled from "styled-components";
import { TimelineWatermarkData } from "../../mock/timeline";
import { Box } from "../Box";
import { motion } from "framer-motion";

interface TimelineItemWatermarkProps {
  data: TimelineWatermarkData;
}

const Wrapper = styled.div`
  img {
    width: 100%;
    height: auto;
    vertical-align: middle;
  }
`;

export const TimelineItemWatermark: React.FC<TimelineItemWatermarkProps> = ({
  data,
}) => {
  return (
    <Wrapper>
      <Box marginLeft={data.offset.x} width="100%" opacity={data.opacity}>
        <img
          src={data.image.src}
          alt={data.image.title}
          width={data.image.width}
          height={data.image.height}
        />
      </Box>
    </Wrapper>
  );
};
